import {
	makeRequest,
	uploadFileRequest,
} from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import {
	CanChangeCredentialsRes,
	DataFileTct,
	GetUserPersonsRes,
	GetUserProfileRes,
	UpdateUserPersonalDetailsDto,
	UpdateUserRepresentativeDto,
	UpdateUserSignatureDto,
	UpdateUserVehicleDataDto,
	UserOrganizationRes,
} from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { ServiceRequestOptions } from '@dealstack/frontend/shared/other/react/ApiWrapper/types';

export const getUserProfile = async (endpoint: string, signal?: AbortSignal) => {
	return await makeRequest<ApiV1.Response<GetUserProfileRes>>(
		{
			endpoint,
			method: HTTP_METHOD.GET,
		},
		{ abortSignal: signal }
	);
};

export const getUserPersons = async () => {
	return await makeRequest<ApiV1.Response<GetUserPersonsRes>>({
		endpoint: API_PATHS.USER_PERSONS_GET,
		method: HTTP_METHOD.GET,
	}).then((resp) => resp.payload);
};

export const getUserOrganizationId = async () => {
	return await makeRequest<ApiV1.Response<UserOrganizationRes>>({
		endpoint: API_PATHS.USER_ORGANIZATION_GET,
		method: HTTP_METHOD.GET,
	}).then((resp) => resp.payload?.organizationId ?? null);
};

export const canChangeCredentials = async (endpoint: string, signal?: AbortSignal) => {
	return await makeRequest<ApiV1.Response<CanChangeCredentialsRes>>(
		{
			endpoint,
			method: HTTP_METHOD.POST,
		},
		{ abortSignal: signal }
	);
};

export const updateUserPersonalDetails = async (
	args: UpdateUserPersonalDetailsDto,
	options?: ServiceRequestOptions
) => {
	await makeRequest<ApiV1.Response<unknown>>(
		{
			endpoint: API_PATHS.USER_PERSONAL_DETAILS_PUT,
			method: HTTP_METHOD.PUT,
			body: JSON.stringify({
				...args,
			}),
		},
		{
			...options,
		}
	);
};

export const updateLegalRepresentativeWithoutMipId = async (
	args: UpdateUserRepresentativeDto,
	options?: ServiceRequestOptions
) => {
	await makeRequest(
		{
			endpoint: API_PATHS.USER_LEGAL_REPRESENTATIVE_WITHOUT_MIP_ID_PUT,
			method: HTTP_METHOD.PUT,
			body: JSON.stringify({
				...args,
			}),
		},
		{
			...options,
		}
	);
};

export const updateVehicleDataWithoutMipId = async (
	args: UpdateUserVehicleDataDto,
	options?: ServiceRequestOptions
) => {
	await makeRequest(
		{
			endpoint: API_PATHS.USER_VEHICLE_DATA_WITHOUT_MIP_ID_PUT,
			method: HTTP_METHOD.PUT,
			body: JSON.stringify({
				...args,
			}),
		},
		{
			...options,
		}
	);
};

export const updateUserSignature = async (
	args: UpdateUserSignatureDto,
	options?: ServiceRequestOptions
) => {
	await makeRequest<ApiV1.Response<unknown>>(
		{
			endpoint: API_PATHS.USER_SIGNATURE_PUT,
			method: HTTP_METHOD.PUT,
			body: JSON.stringify({
				...args,
			}),
		},
		{
			...options,
		}
	);
};

export const uploadUserSignatureImageFile = async (args: { formData: FormData }) => {
	return uploadFileRequest<ApiV1.Response<DataFileTct>>(
		{
			endpoint: API_PATHS.FILE_SIGNATURE_FILE_POST,
			method: HTTP_METHOD.POST,
		},
		args.formData
	).then((response) => response.payload);
};
